import React, { useContext, useState } from "react";
import "./ConfirmationPopup.css";
import { motion } from "framer-motion";
import MDSpinner from "react-md-spinner";
import { AppContext } from "../../Util/contexts/AppContext";
import {
  backdropMotionProps,
  modalPopupMotionProps,
} from "../../Util/animations/Animations_v2";

export default function ConfirmationPopup({
  closePopup,
  title,
  description,
  children,
  confirmFunction,
  continueOnly,
  confirmationText,
}) {
  const { primaryColor, userData } = useContext(AppContext);
  const [confirmFunctionOutstanding, setConfirmFunctionOutstanding] =
    useState(false);

  const { AnimationsDisabled } = userData;

  const handleConfirm = async () => {
    setConfirmFunctionOutstanding(true);
    if (confirmFunction ? await confirmFunction() : true) closePopup();
    else setConfirmFunctionOutstanding(false);
  };

  const buttonContainerClassname = continueOnly
    ? "confirmationPopupButtonWrapperOneButton"
    : "confirmationPopupButtonWrapper";

  return (
    <div className="confirmationPopupPageContainer">
      <motion.div
        className="confirmationPopupBackdrop"
        onClick={closePopup}
        {...backdropMotionProps(AnimationsDisabled)}
        key="confirmationPopupBackdrop"
      />
      <motion.div
        className="confirmationPopupContainer"
        {...modalPopupMotionProps(AnimationsDisabled)}
        key="confirmationPopupContainer"
      >
        <button className="popupCloseButton" onClick={closePopup} />
        <h2 className="confirmationPopupTitle">{title}</h2>
        <p className="confirmationPopupDescription">{description}</p>
        {children}
        <div className={buttonContainerClassname}>
          {!continueOnly && (
            <button
              className="confirmationPopupButton secondaryButton"
              onClick={closePopup}
            >
              Cancel
            </button>
          )}
          {confirmFunctionOutstanding ? (
            <div className="confirmationPopupSpinnerContainer">
              <MDSpinner
                className="confirmationPopupSpinner"
                size={30}
                singleColor={primaryColor}
              />
            </div>
          ) : (
            <button
              className="confirmationPopupButton tertiaryButton"
              onClick={handleConfirm}
            >
              {confirmationText || "Confirm"}
            </button>
          )}
        </div>
      </motion.div>
    </div>
  );
}
